const Events = [
    {
        name: 'PROGRAMMING CONTEXT',
        img: ' https://i.ibb.co/tQJSKFs/Programming.png',
        Rule: 'Maximum 3 Team member',
        Fee: '450 Taka'

    },
    {
        name: 'ICT QUIZ',
        img: 'https://i.ibb.co/p2hFxXs/Hacathon.png',
        Fee: '100 Taka'

    },
    {




        name: 'PROJECT SHOWCASING',
        img: 'https://i.ibb.co/tMwSX0W/Project-Showcaseing-Hard.png',
        Rule: 'Maximum 2 Team member',
        Fee: '300 Taka'

    },
    {
        name: 'HACKATHON',
        img: 'https://i.ibb.co/pKDpkQC/Project-Showcaseing-Soft.png',
        Rule: 'Maximum 3 Team member',
        Fee: '400 Taka'

    },
    {
        name: 'GAMEING',
        img: 'https://i.ibb.co/6rq1JnX/Gaming.png',
        Rule: 'Maximum 2 Team member',
        Fee: '300 Taka'

    },

    {
        name: 'WORKSHOP',
        img: 'https://i.ibb.co/pKDpkQC/Project-Showcaseing-Soft.png',

        Fee: 'Free'

    },

]
export default Events;